import React, { FC } from 'react';
import cx from 'clsx';
import queryString from 'query-string';

import { CHECKOUT_DETAILS_SHIMMER_ID } from './const';
import { PageLayout } from 'components/PageLayout';
import { HeaderShimmer } from 'components/PageLayout/Header/HeaderShimmer';
import { Card } from 'components/Card';
import { InvoiceSummaryShimmer } from 'components/InvoiceSummary/InvoiceSummaryShimmer';

import { PaymentInfoShimmer } from '../PaymentInfo/PaymentInfoShimmer';
import { TotalsShimmer } from '../Totals/TotalsShimmer';
import { CustomerInfoShimmer } from '../CustomerInfo/CustomerInfoShimmer';
import { LineItemsShimmer } from '../LineItems/LineItemsShimmer';

import styles from './styles.module.scss';

type CheckoutDetailsShimmerProps = {
  hideHeader?: boolean;
};

const CHECKOUT = 'checkout';

const CheckoutDetailsShimmer: FC<CheckoutDetailsShimmerProps> = ({ hideHeader = false }) => {
  const { mode } = queryString.parse(window.location.search);

  const isInvoiceMode = mode !== CHECKOUT;

  return (
    <PageLayout data-testid={CHECKOUT_DETAILS_SHIMMER_ID} header={!hideHeader && <HeaderShimmer />}>
      <Card className={styles.card}>
        <h1 aria-hidden={true} className={cx('shimmer', styles.heading)} />

        {isInvoiceMode
          ? <InvoiceSummaryShimmer />
          : <LineItemsShimmer />
        }

        <TotalsShimmer isInvoiceMode={isInvoiceMode} />

        <section>
          {!isInvoiceMode && <CustomerInfoShimmer />}
          <PaymentInfoShimmer />
        </section>

        <p className={cx('shimmer', styles.submitButton)} />
      </Card>
    </PageLayout>
  );
};

export { CheckoutDetailsShimmer };
